module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_7016.086b6fe0.png";